import React, {useContext, useState} from 'react';
import {Edit} from 'react-feather';
import Modal from "react-modal";
import introImage from "../../images/svg/message/no_messages.svg";
import {
    CONVERSATION_RELOAD,
    FILTER_RELOAD,
    MESSAGE_RELOAD,
    UNREAD_CHECK_EVENT,
    ACTIVE_CONVERSATION_CHANGED
} from "../../services/events";
import {patchConversationRead} from "../../services/api/messaging";
import {BROKER, VENDOR} from "../../services/constants/CompanyType";
import {ACTIVE, UNREAD} from "../../services/constants/ConversationFilterType";
import {AuthContext} from "../../context/AuthContext";
import ConversationMessaging from "./ConversationMessaging";
import ConversationFilters from "./ConversationFilters";
import ModalStartConversation from "../../components/Modal/ModalStartConversation";
import ConversationList from "./ConversationList";

const Messaging = ({newMessages}) => {
    Modal.setAppElement('#root');

    const authData = useContext(AuthContext);
    const [activeFilterOption, setActiveFilterOption] = useState({page: 1, status: ACTIVE});
    const [activeConversation, setActiveConversation] = useState(null);
    const [startConversationOpen, setStartConversationOpen] = useState(false);
    const [showEmptyState, setShowEmptyState] = useState(false);

    const handleToggleStartConversation = () => {
        setStartConversationOpen(!startConversationOpen);
    };
    const handleSelectFilter = (filter) => {
        setActiveFilterOption({page: 0, status: filter.key});
        setActiveConversation(null);
    };
    const handleConversationStart = () => {
        setActiveFilterOption({page: 0, status: ACTIVE});
        setActiveConversation(null);
    };
    const handleSelectConversation = async (conversation, skipRead = true) => {
        if (conversation?.id !== activeConversation?.id) {
            const activeConversationChangedEvent = new Event(ACTIVE_CONVERSATION_CHANGED);
            document.dispatchEvent(activeConversationChangedEvent);
        }

        if (conversation?.unread && !skipRead) {
            try {
                if (!skipRead) {
                    const res = await patchConversationRead(conversation.id);
                    if (res.message !== 'Successful')
                        return
                }

                const filterEvent = new Event(FILTER_RELOAD);
                document.dispatchEvent(filterEvent);

                if (activeFilterOption.status !== UNREAD || skipRead) {
                    const reloadEvent = new Event(CONVERSATION_RELOAD);
                    document.dispatchEvent(reloadEvent);
                }

                const readEvent = new Event(UNREAD_CHECK_EVENT);
                document.dispatchEvent(readEvent);

                const messageReloadEvent = new Event(MESSAGE_RELOAD);
                document.dispatchEvent(messageReloadEvent);

                conversation.unread = skipRead;
                conversation.skipRead = skipRead;


            } catch (e) {
                console.error(e);
            }
        }

        if (conversation) {
            setActiveConversation(conversation);
        }
    };
    const handleEmptyState = (noConversations) => {
        setShowEmptyState(noConversations);
    };
    const handleMessageSent = (conversation) => {
        const messageReloadEvent = new Event(MESSAGE_RELOAD);
        document.dispatchEvent(messageReloadEvent);

        const reloadEvent = new Event(CONVERSATION_RELOAD);
        document.dispatchEvent(reloadEvent);

        console.log('handleEmptyState')
        setActiveConversation(conversation);
    };
    const handleConversationArchived = (conversation) => {
        const reloadEvent = new Event(CONVERSATION_RELOAD);
        document.dispatchEvent(reloadEvent);

        const filterEvent = new Event(FILTER_RELOAD);
        document.dispatchEvent(filterEvent);

        console.log('handleConversationArchived')
        conversation.archived = true;
        setActiveConversation(conversation);
    };
    const handleConversationSyncUsers = (authUserRemoved) => {
        if (authData.type === BROKER) {
            return false;
        }
        if (authUserRemoved) {
            setActiveConversation(null);
        }
        const reloadEvent = new Event(CONVERSATION_RELOAD);
        document.dispatchEvent(reloadEvent);

        const messageReloadEvent = new Event(MESSAGE_RELOAD);
        document.dispatchEvent(messageReloadEvent);
    };

    return (
        <div className="sl-container sl-m-auto sl-my-8 sl-h-full">
            <div className="sl-flex sl-rounded-lg sl-shadow-md sl-border-1 sl-bg-white sl-h-full">
                <div className="sl-sidebar-messaging">
                    <div className="sl-sidebar-header sl-border-bottom sl-w-full">
                        <div className="sl-flex sl-align-center sl-justify-between sl-px-5 sl-py-5 sl-w-full">
                            <div className="sl-flex">
                                <span
                                    className={"sl-font-semibold sl-text-gray-900 sl-font-inter sl-text-24"}>Messaging</span>
                                {(newMessages > 0) &&
                                    <div
                                        className="sl-h-7 sl-min-w-8 sl-py-1-point-5 sl-ml-2 sl-rounded-full
                                        sl-badge-sm sl-badge-primary sl-text-xs sl-font-semibold sl-text-primary-700 sl-flex justify-center">
                                        <span className={"sl-align-self-center"}>{newMessages}</span>
                                    </div>}
                            </div>
                            {authData.type === BROKER && <div>
                                <button onClick={handleToggleStartConversation}
                                        className="sl-btn-tertiary sl-px-2 sl-py-2">
                                    <Edit size={20}/>
                                </button>

                                <Modal
                                    isOpen={startConversationOpen}
                                    onRequestClose={() => handleToggleStartConversation()}
                                    className="sl-modal-content sl-max-modal"
                                    overlayClassName="sl-modal sl-block sl-rounded-md sl-bg-gray-900-opacity-50">
                                    <ModalStartConversation onHandleToggle={handleToggleStartConversation}
                                                            onMessageSent={handleConversationStart}/>
                                </Modal>
                            </div>}
                        </div>
                        <ConversationFilters filterOptions={activeFilterOption}
                                             onHandleSelectFilter={handleSelectFilter}
                                             onEmptyState={handleEmptyState}/>
                    </div>
                    <ConversationList
                        onHandleConversationArchived={handleConversationArchived}
                        authData={authData} activeConversation={activeConversation}
                        activeFilterOptions={activeFilterOption}
                        onSelectConversation={handleSelectConversation}/>
                </div>

                <div className="sl-flex sl-grow-1 sl-justify-start sl-align-flex-start sl-w-full sl-h-full sl-mb-5">
                    {activeConversation ? <div className="sl-grow-1">
                        <ConversationMessaging authData={authData}
                                               activeConversation={activeConversation}
                                               onHandleConversationSyncUsers={handleConversationSyncUsers}
                                               onHandleConversationArchived={handleConversationArchived}
                                               onHandleMessageSent={handleMessageSent}/>
                    </div> : showEmptyState &&
                        <div
                            className="sl-flex sl-flex-col sl-justify-center sl-align-center sl-w-120 sl-mt-3i sl-mx-auto">
                            <img className="sl-m-auto sl-h-50vh sl-max-h-95" src={introImage} srcSet={introImage}
                                 alt="intro"/>
                            <div className="sl-flex sl-flex-col sl-justify-center sl-gap-6">
                                {authData.type === VENDOR &&
                                    <div className="sl-flex sl-flex-col sl-justify-center sl-gap-2">
                                        <a className="sl-badge sl-badge-lg sl-badge-blue-light sl-m-auto sl-no-underline"
                                           href="/messaging">What’s new</a>
                                        <div className="sl-font-semibold sl-heading-xs sl-text-gray-700">
                                            Messaging
                                        </div>
                                        <div className="sl-font-normal sl-text-md sl-text-gray-500">
                                            Shortlister broker subscribers can send you messages and start a
                                            conversation within the Shortlister Platform. You'll receive an email
                                            notification when you have a new message.
                                        </div>
                                    </div>}
                                {authData.type === BROKER &&
                                    <div className="sl-flex sl-flex-col sl-justify-center sl-gap-2">
                                        <div className="sl-font-semibold sl-heading-xs sl-text-gray-700">Send your first
                                            message
                                        </div>
                                        <div className="sl-font-normal sl-text-md sl-text-gray-500">
                                            Send a message to a vendor and start a conversation. You'll receive an email
                                            notification when you receive a response.
                                        </div>
                                    </div>}

                                {authData.type === BROKER &&
                                    <div className="sl-flex sl-flex-col sl-justify-center sl-gap-4">
                                        <button onClick={handleToggleStartConversation}
                                                className="sl-btn sl-btn-primary sl-btn-lg sl-m-auto sl-font-medium sl-text-md">
                                            Send a Message
                                        </button>
                                    </div>}
                            </div>
                        </div>}
                </div>
            </div>
        </div>
    );
};

export default Messaging;
